import { openWindow } from "src/redux/actions/Mosaic.Actions";
import { MosaicDirection } from "src/utils/MosaicTree";
import { openDrawer } from "src/redux/actions/App.Actions";
import { IAirport } from "@vmosolutions/oc-interfaces";

// EDIT PAIRINGS
const editPairing = (dispatch: any, pairingId: string): void => {
  dispatch(openDrawer());
  dispatch(openWindow("Edit Pairing", "PairingEditorWindow", [], { pairingId }, "context", true, MosaicDirection.Right, 940));
};

// SHOW AIRPORT INFO
const openAirportInfoWindow = (dispatch: any, airport: IAirport): void => {
  const windowProps = { airportInfo: airport };
  dispatch(openDrawer());
  dispatch(openWindow("Airport Info", "AirportInfoWindow", [], windowProps, null));
};

/**
 * Shared function used in both the ShortCodeChip as well as the header search component.
 * @param data - collection's object id or complete data.
 * @param type - type of shortcode item i.e. pairing, flight
 * @param dispatch - redux dispatch to open window.
 */
export const handleEditTypes =
  (data: string | IAirport, type: string, dispatch: any) =>
  (event: React.MouseEvent): void => {
    event.stopPropagation(); // important when used in the table where rows are clickable.
    switch (type) {
      case "pairing":
        editPairing(dispatch, data as string);
        break;
      case "airport":
        openAirportInfoWindow(dispatch, data as IAirport);
        break;
    }
  };
